import { createVNode, render } from 'vue';

let rootApp:any = null;
const createInstance = (options:any, container: any) => {
  const { onOk, onClose, className, autoClose, ...others } = options;
  const div = document.createElement('div');
  div.className = `dialog-custom-confirm ${className}`;
  const closeFn = () => {
    onClose &&  onClose();
    setTimeout(() => {
      render(null, div); // 卸载
      container.removeChild(div);
    }, 50);
  };

  const ModalComp = import('./index.vue');

  if (ModalComp.then) {
    ModalComp.then((v:any) => {
      const vNode = createVNode(v.default, {
        visible: true,
        'append-to-body': false,
        ...others,
        onOnClose: closeFn,
        onOnOk: () => {
          onOk &&  onOk(closeFn);
        }
      });
      vNode.appContext = rootApp && rootApp._context;
      container && container.appendChild(div);

      render(vNode, div); // 挂载
      if (autoClose) {
        setTimeout(() => {
          closeFn();
        }, autoClose);
      }
    });
  }

};

const handler = (options:any) => {
  const has = document.querySelector(`.${options.className}`);
  if (!has) {
    const container = document.body;
    createInstance(options, container);
  }
  return !has;
};

export const $confirm = {
  success: (options:any) => {
    const className = options.className || 'dialog-custom-success';
    return handler({
      icon: 'success',
      ...options,
      className
    });
  },
  warning: (options:any) => {
    const className = options.className || 'dialog-custom-warning';
    return handler({
      icon: 'warning',
      ...options,
      className
    });
  },
  info: (options:any) => {
    const className = options.className || 'dialog-custom-info';
    return handler({
      ...options,
      className
    });
  }
};

export const install = (app:any) => {
  rootApp = app;
};

export default {
  $confirm,
  install
};

